module.exports = __webpack_public_path__ + "static/media/trillio_medium.3368f620.webp";